var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 67,
    viewBox: "0 0 70 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0737 37.3158C52.7474 38.6105 51.9895 40.4737 52.179 42.4632C52.4632 45.8737 55.5895 48.3684 59 48.3684H65V52.1263C65 58.6632 59.6632 64 53.1263 64H21.2C22.1789 63.1789 23.0316 62.1684 23.6947 61.0316C24.8632 59.1368 25.5263 56.8947 25.5263 54.5263C25.5261 52.1467 24.8535 49.8155 23.586 47.8015C22.3186 45.7875 20.5079 44.1726 18.3626 43.1428C16.2173 42.1131 13.8247 41.7104 11.4605 41.9813C9.09637 42.2521 6.85683 43.1854 5 44.6737V30.8737C5 24.3368 10.3368 19 16.8737 19H53.1263C59.6632 19 65 24.3368 65 30.8737V35.4211H58.6211C56.8526 35.4211 55.2421 36.1158 54.0737 37.3158V37.3158Z",
    stroke: "#4C3CA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 32.7726V18.7599C5 15.111 7.32913 11.8608 10.8707 10.573L36.2039 1.37424C37.1218 1.04183 38.11 0.928429 39.0835 1.04379C40.057 1.15915 40.9869 1.49982 41.7933 2.03656C42.5997 2.5733 43.2585 3.29007 43.7131 4.12536C44.1678 4.96064 44.4048 5.88949 44.4038 6.83216V18.4839M19.3576 31.5155H41.6918M69 37.556V43.8724C69 45.5589 67.5961 46.9387 65.8094 47H59.5559C56.11 47 52.9513 44.5777 52.6642 41.2661C52.4728 39.3344 53.2385 37.5253 54.5785 36.2681C55.7591 35.103 57.3863 34.4284 59.173 34.4284H65.8094C67.5961 34.4897 69 35.8695 69 37.556V37.556Z",
    stroke: "#4C3CA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1625 53.4353H8.85002M13.5 48.872V58.2174M26 53.4978C26 55.8419 25.3438 58.0611 24.1875 59.9364C23.5313 61.0616 22.6875 62.0618 21.7188 62.8744C19.5313 64.8435 16.6563 66 13.5 66C11.3455 66.0045 9.22701 65.4477 7.35302 64.3845C5.47904 63.3213 3.91419 61.7883 2.81252 59.9364C1.62296 57.9999 0.995409 55.7706 1.00003 53.4978C1.00003 49.5596 2.81252 46.0277 5.68752 43.7461C7.52501 42.2731 9.74122 41.3493 12.0808 41.0812C14.4203 40.8132 16.788 41.2117 18.9109 42.2309C21.0339 43.2501 22.8257 44.8485 24.0799 46.8419C25.3342 48.8352 25.9998 51.1425 26 53.4978V53.4978Z",
    stroke: "#4C3CA6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterest);
export default __webpack_public_path__ + "static/media/interest.09d10efe833b36777e73686cd1bd4173.svg";
export { ForwardRef as ReactComponent };